import { render, staticRenderFns } from "./AgentLoginForm.vue?vue&type=template&id=2d00b124&scoped=true&"
import script from "./AgentLoginForm.vue?vue&type=script&lang=js&"
export * from "./AgentLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00b124",
  null
  
)

export default component.exports